module.exports = __webpack_public_path__ + "static/scale-model-of-love-lock-bridge-san-antonio-in-san-antonio-texas-a84c66cf1ad7762392ad8a2847797a8d.png";